<template>
  <div>
    <a-row type="flex" class="simiot-margin-bottom-15px">
      <a-col flex="70px">
        <a-icon
          type="wallet"
          theme="twoTone"
          :style="{fontSize: '55px'}"
        />
      </a-col>

      <a-col flex="200px">
        <a-spin :spinning="loadingCommission">
          <a-statistic
            class="simiot-statistic"
            title="佣金余额"
            prefix="￥"
            :precision="2"
            :value="commission_available"
          />
        </a-spin>
      </a-col>

      <a-col flex="200px">
        <a-spin :spinning="loadingCommission">
          <a-statistic
            class="simiot-statistic"
            title="累积佣金"
            prefix="￥"
            :precision="2"
            :value="commission_total"
          />
        </a-spin>
      </a-col>
    </a-row>

    <search-agent-commission-statistic @submit="submitSearch" />

    <div class="simiot-table-operation-buttons">
      <a-space>
        <a-button type="primary" @click="exportData">导出</a-button>
      </a-space>
    </div>

    <a-table
      size="middle"
      :columns="columns"
      :data-source="data"
      :loading="loadingTable"
      :pagination="false"
      row-key="id"
    >
      <div slot="billable_no" slot-scope="billable_no, record">
        <a @click="showInfoModal(record)">{{ billable_no }}</a>
      </div>
    </a-table>

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchTableData"
    />

    <show-commission-statistic
      v-if="isShowInfoModal"
      :visible.sync="isShowInfoModal"
      :id="this.showingId"
      :billable-type="this.showingBillableType"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import SearchAgentCommissionStatistic from '@/views/commission_statistics/agent/Search'
import { findAgentCommissionStatistics, exportAgentCommissionStatistics } from '@/api/commission_statistic'
import ShowCommissionStatistic from '@/views/commission_statistics/agent/info'
import { findAgentFinanceOverview } from '@/api/agent'
import { formatFloat } from '@/utils/filter'
import { exportExcel } from '@/api/excel'

export default {
  name: 'AgentCommissionStatisticList',
  components: {
    ShowCommissionStatistic,
    SearchAgentCommissionStatistic,
    Pagination
  },
  data() {
    return {
      commission_available: undefined,
      commission_total: undefined,
      data: [],
      loadingCommission: true,
      loadingTable: true,
      showingId: 0,
      showingBillableType: 0,
      isShowInfoModal: false,
      pagination: {
        total_count: 0
      },
      query: {
      }
    }
  },
  computed: {
    agentId() {
      return parseInt(this.$route.params.id)
    },

    columns() {
      return [
        {
          title: '时间',
          dataIndex: 'sort_time'
        },
        {
          title: '佣金收支项',
          dataIndex: 'billable_type_display'
        },
        {
          title: '事件批次',
          scopedSlots: { customRender: 'billable_no' },
          dataIndex: 'billable_no'
        },
        {
          title: '佣金(元)',
          customRender: formatFloat,
          dataIndex: 'total_fee'
        },
        {
          title: '佣金余额(元)',
          customRender: formatFloat,
          dataIndex: 'commission'
        }
      ]
    }
  },
  created() {
    this.fetchCommissionStatistic()
    this.fetchTableData()
  },
  methods: {
    showInfoModal(record) {
      this.showingId = record.id
      this.showingBillableType = record.billable_type_slug
      this.isShowInfoModal = true
    },

    submitSearch(search) {
      // 赋值搜索条件，保留 per_page
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search)
      this.fetchTableData()
    },

    fetchCommissionStatistic() {
      this.loadingCommission = true
      findAgentFinanceOverview(this.agentId).then((res) => {
        if (res.code === 0) {
          this.commission_available = res.data.commission_available
          this.commission_total = res.data.commission_total
        }
        this.loadingCommission = false
      })
    },

    fetchTableData() {
      this.loadingTable = true
      findAgentCommissionStatistics(Object.assign({ agent_id: this.agentId }, this.query)).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loadingTable = false
      })
    },

    exportData() {
      exportAgentCommissionStatistics(Object.assign({ agent_id: this.agentId }, this.query)).then((res) => {
        if (res.code === 0 && res.data.is_direct_download === true) {
          exportExcel(res.data.id, res.data.file_name)
        }
      })
    }
  }
}
</script>

